var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoOnly(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 40,
    viewBox: "0 0 62 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.3334 37.0388C61.3334 38.6737 60.0051 40 58.3677 40C56.7303 40 55.402 38.6737 55.402 37.0388C55.402 35.4039 56.7303 34.0776 58.3677 34.0776C60.0003 34.0776 61.3334 35.4039 61.3334 37.0388Z",
    fill: "#03CDEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7843 3.94984C11.0417 3.94984 3.9559 11.0248 3.9559 19.754C3.9559 28.4832 11.0417 35.5582 19.7843 35.5582H26.2133C27.3049 35.5582 28.1936 36.4408 28.1936 37.5356C28.1936 38.6255 27.3097 39.5129 26.2133 39.5129H19.7843C8.85851 39.5081 0 30.6631 0 19.754C0 8.84495 8.85851 0 19.7843 0H59.353C60.4446 0 61.3333 0.882566 61.3333 1.97733C61.3333 3.06728 60.4494 3.95467 59.353 3.95467H19.7843V3.94984Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8726 19.754C11.8726 15.3894 15.4179 11.8543 19.7844 11.8543H35.6128V38.0275C35.6128 39.1174 36.4967 40.0048 37.5932 40.0048C38.6848 40.0048 39.5736 39.1222 39.5736 38.0275V9.87699C39.5736 8.78705 38.6896 7.89966 37.5932 7.89966H19.7844C13.2299 7.89966 7.91187 13.2047 7.91187 19.754C7.91187 26.3033 13.225 31.6084 19.7844 31.6084H26.2133C27.3049 31.6084 28.1937 30.7258 28.1937 29.631C28.1937 28.5363 27.3098 27.6537 26.2133 27.6537H19.7844C15.4131 27.6537 11.8726 24.1186 11.8726 19.754Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5049 7.89966C46.5965 7.89966 47.4853 8.78222 47.4853 9.87699V38.0275C47.4853 39.1174 46.6013 40.0048 45.5049 40.0048C44.4133 40.0048 43.5245 39.1222 43.5245 38.0275V9.87699C43.5245 8.78705 44.4133 7.89966 45.5049 7.89966Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnly);
export default __webpack_public_path__ + "static/media/LogoOnly.030db57bb5bce1a1afe8d65534e60a20.svg";
export { ForwardRef as ReactComponent };